interface FormActionProps {
  action?: string;
  text: string;
  disabled?: boolean;
  tabIndex?: number;
}

export default function FormAction({
  action = 'submit',
  text,
  disabled = false,
  tabIndex,
}: FormActionProps) {
  return (
    <>
      <input
        type={action}
        tabIndex={tabIndex ?? undefined}
        className="group relative w-full flex text-center justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-midnight hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-eirly-500  disabled:!bg-eirly-500/50"
        value={text}
        disabled={disabled}
      />
    </>
  );
}
